import React, { createContext, useContext } from 'react';
import defaultLogo from '../assets/images/sas-logo.png';
import { getSiteDetails } from '../services/TemplateService';
import useAsync from '../hooks/useAsync';

let customFieldNames = {};
const DEFAULT_PAGE_COMPONENT = 'DEFAULT';

const defaultAppData = {
  logo: '',
  correspondent: '',
  url: '',
  brokerName: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  isOnboarding: false,
};
const appContext = createContext({
  // eslint-disable-next-line
  getPageCustomFieldName: (defaultLabel, componentName) => {},
  defaultAppData,
});

export const AppContextProvider = ({ children }) => {
  const [appData, setAppData] = React.useState(defaultAppData);

  useAsync(getSiteDetails, (returnValue) => {
    if (returnValue?.correspondent) {
      const {
        correspondent,
        photo,
        url,
        brokerName,
        address,
        city,
        state,
        zip,
        isOnboarding,
      } = returnValue.correspondent;

      const copy = { ...appData };
      copy.correspondent = correspondent;
      copy.url = url;
      copy.brokerName = brokerName;
      copy.brokerAddress = address;
      copy.brokerCity = city;
      copy.brokerState = state;
      copy.brokerZip = zip;
      copy.isOnboarding = isOnboarding;

      if (photo) {
        copy.logo = photo;
      } else {
        copy.logo = defaultLogo;
      }
      setAppData(copy);
    }
  });

  const getPageCustomFieldName = (defaultLabel, pageComponent) => {
    if (customFieldNames[defaultLabel]) {
      if (customFieldNames[defaultLabel][pageComponent])
        return customFieldNames[defaultLabel][pageComponent];

      if (customFieldNames[defaultLabel][DEFAULT_PAGE_COMPONENT])
        return customFieldNames[defaultLabel][DEFAULT_PAGE_COMPONENT];
    }

    return defaultLabel;
  };

  return (
    <appContext.Provider value={{ ...appData, getPageCustomFieldName }}>
      {children}
    </appContext.Provider>
  );
};

// custom hook to use the appContext and access global application data
export const useAppContext = () => useContext(appContext);
